import React from 'react';
import PropTypes from 'prop-types';

class Chooser extends React.PureComponent {
  toogleIndex = ({attr, index}) => {
    let { indexList, toogleIndex } = this.props;
    if(indexList.indexOf(index) === -1) {
      indexList = [...indexList, index];
    } else {
      indexList = indexList.filter(item => item !== index);
    }
    toogleIndex({attr, indexList});
  }
  render () {
    const {
      attr,
      text,
      isOpen,
      locale,
      itemList,
      indexList,
      toggleList,
    } = this.props;
    return (
      <div className={`chooser ${isOpen && "open"} ${locale}`}>
        <span
          onClick={() => toggleList(attr)}
          className={`text ${indexList.length && 'blue'}`}
        >{text}</span>
        {isOpen &&
          <ul className="list">
            {itemList.map((item, index) =>
              <li key={item} onClick={() => this.toogleIndex({attr, index})}>
                <span className={`ion-checkmark ${indexList.indexOf(index) > -1 && "checked"}`} />
                {item}
              </li>
            )}
          </ul>
        }
      </div>
    );
  }
}

export default Chooser;

Chooser.propTypes = {
  attr: PropTypes.string,
  text: PropTypes.string,
  isOpen: PropTypes.bool,
  locale: PropTypes.string,
  itemList: PropTypes.array,
  indexList: PropTypes.array,
  toggleList: PropTypes.func,
  toogleIndex: PropTypes.func,
};

Chooser.defaultProps = {
  locale: ''
};



// WEBPACK FOOTER //
// ./src/pages/CasePage/components/Chooser.js